import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UsuarioEsquema } from '../../usuarioEsquema';
import { Usuario } from '../../usuario';
import { Invsalida } from '../invinterfaces/invsalida';
import { Invencsalida } from '../invinterfaces/invencsalida';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { ConfInicialesService } from 'src/app/servicios/conf-iniciales.service';
import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class InvsalidaprodService {
  public url: string;
  public decimalesPrecioSal: number;
  public decimalesCantidadSal: number;
  public decimalesTotalSal: number;
  public auxsalto;
  public date1: any;
  public hora: any;
  public detkardexsarray: Invsalida[][] = [];
  public encsalidaSeleccionada: Invencsalida[] = []
  public totalSalidaarray: string[] = [];
  public totalSalidaCantidadarray:string[]=[]
  public encordprod: string = ''
  public encchkcentra
  
  public way: string;
  constructor(private http: HttpClient,
    public usuarioEsquema: UsuarioEsquema,
    public usuario: Usuario,
    private confIniciales: ConfInicialesService,
    private init: NuevoComponentService) {
    this.way = sessionStorage.getItem('way');
  }
  erBodCodigo1(strArtCodigo, strtipo, strCodigo) {
    return this.http.post<any[]>(this.way + '/inventario/entradas/76d786b30d94300', {
      elementos: {
        BOD_CODIGO: strCodigo,
        ArtCodigo: strArtCodigo,
        strTIPO: strtipo
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  encontrarArtCntaySer(strArtCodigo, strtipo) {
    return this.http.post<any[]>(this.way + '/ventas/facturas/75d98bf76adab8000000', {
      elementos: {
        ArtCodigo: strArtCodigo,
        strTIPO: strtipo
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  ValidaEnSaOrdProd(salida: Invencsalida) {

    return this.http.post<any[]>(this.way + '/inventario/kardexsalidas/20eebafc5636dc0000', {
      elementos: {
        p_prod_numero: salida.ENCORDPRO_NUMERO,
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  ValidaPonderacion(salida: Invencsalida) {

    return this.http.post<any[]>(this.way + '/inventario/kardexsalidas/7d5593559c5db0000000000000000', {
      elementos: {
        p_prod_numero: salida.ENCORDPRO_NUMERO,
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  borrarEncSalida(salida: Invencsalida): Observable<any> {

    return this.http.post<any[]>(this.way + '/inventario/kardexsalidas/gmey60v3p7gmdqn', {
      elementos: {
        p_KAR_nro_1: salida.KAR_NRO,
      },
    }, this.confIniciales.httpOptions());
  }
  eliminarAsientoCont(salida): Observable<any> {

    return this.http.post<any[]>(this.way + '/inventario/kardexsalidas/nmmj0hg4se1zahz', {
      elementos: {
        p_ASI_nro: salida,
        p_COM_codigo_2: '01',
      },
    }, this.confIniciales.httpOptions());
  }
  seleccionarRegistro(tipo, cadena, condicion): Observable<any> {
    return this.http.post<any>(this.way + '/inventario/kardexsalidas/38eab992c5d5be000000000', {
      elementos: {
        p_opcion: tipo,
        p_filtro: 'KAR_ORIGEN = \'PROD\' AND KAR_TIPO=\'SA\' ',
        p_condicion: condicion
      }
    }, this.confIniciales.httpOptions());
  }
  consultarDetKardex(codigo): Observable<any[]> {

    return this.http.post<any[]>(this.way + '/inventario/kardexsalidas/9w6rp0a3psq29sw', {
      elementos: {
        p_KAR_nro_1: codigo,
        p_com_codigo: '01'
      },
    }, this.confIniciales.httpOptions());
  }
  getcantidadGrabadaDoc(strnroDocumento, strcodArticulo): Observable<any> {
    console.log(strnroDocumento, strcodArticulo);
    return this.http.post<any[]>(this.way + '/inventario/kardexsalidas/180d2zzl3dhh0dv', {
      elementos: {
        nroDocumento: strnroDocumento,
        codArticulo: strcodArticulo,
      },
    }, this.confIniciales.httpOptions());
  }
  getExistenciaArt(strTipo, strartCod, strbodCod, strfecha, strhora): Observable<any> {
    return this.http.post<any[]>(this.way + '/inventario/kardexsalidas/ej234mlq0zshp0x', {
      elementos: {
        tipo: strTipo,
        artCod: strartCod,
        bodCod: strbodCod,
        fecha: strfecha,
        hora: strhora
      },
    }, this.confIniciales.httpOptions());
  }
  parseToIntAndScale(n) {
    const s = String(n);
    if (s.indexOf('e') !== -1) {
      return this.parseToIntAndScale(Number(s).toFixed(18).replace(/0+$/, ''));
    }
    const parts = s.split('.');
    const scale = parts[1] ? parts[1].length : 0
    const intVal = Number(parts.join(''));
    return { intVal, scale }
  }
  toScalate(n, decimales) {
    if (isNullOrUndefined(n) || n === '') {
      return 0
    }
    const p = this.parseToIntAndScale(n);
    if (p.scale === decimales) {
      return p.intVal
    }
    if (p.scale < decimales) {
      return p.intVal * Math.pow(10, decimales - p.scale)
    } else {
      const factor = Math.pow(10, p.scale - decimales)
      return Math.round(p.intVal / factor)
    }
  }

 calcularTotal() {
    let dblCostoTotal = 0;
    let costotobien = 0
    let cantidadbien=0;

    for (let fila = 0; fila < this.detkardexsarray[this.init.tabs[this.init.tabindex].indice].length; fila++) {
      dblCostoTotal = 0;
      dblCostoTotal = this.detkardexsarray[this.init.tabs[this.init.tabindex].indice][fila].DETKAR_COSTOUNIT * this.detkardexsarray[this.init.tabs[this.init.tabindex].indice][fila].DETKAR_CANTIDAD;
      this.detkardexsarray[this.init.tabs[this.init.tabindex].indice][fila].DETKAR_COSTOTOTAL = dblCostoTotal;
    }
    let dblCostoTotalGlobal = 0;
    for (let fila1 = 0; fila1 < this.detkardexsarray[this.init.tabs[this.init.tabindex].indice].length; fila1++) {
      this.detkardexsarray[this.init.tabs[this.init.tabindex].indice][fila1].DETKAR_CANTIDAD = Number(this.detkardexsarray[this.init.tabs[this.init.tabindex].indice][fila1].DETKAR_CANTIDAD).toFixed(this.decimalesCantidadSal);
      this.detkardexsarray[this.init.tabs[this.init.tabindex].indice][fila1].DETKAR_COSTOUNIT = Number(this.detkardexsarray[this.init.tabs[this.init.tabindex].indice][fila1].DETKAR_COSTOUNIT).toFixed(this.decimalesPrecioSal);
      this.detkardexsarray[this.init.tabs[this.init.tabindex].indice][fila1].DETKAR_COSTOTOTAL = Number(this.detkardexsarray[this.init.tabs[this.init.tabindex].indice][fila1].DETKAR_COSTOTOTAL).toFixed(this.decimalesTotalSal);
      dblCostoTotalGlobal = dblCostoTotalGlobal + Number(this.detkardexsarray[this.init.tabs[this.init.tabindex].indice][fila1].DETKAR_COSTOTOTAL);

      costotobien += this.toScalate(this.detkardexsarray[this.init.tabs[this.init.tabindex].indice][fila1].DETKAR_COSTOTOTAL, this.decimalesTotalSal)
      cantidadbien  += this.toScalate(this.detkardexsarray[this.init.tabs[this.init.tabindex].indice][fila1].DETKAR_CANTIDAD, this.decimalesCantidadSal)
    }
    dblCostoTotalGlobal = Number(costotobien / Math.pow(10, this.decimalesTotalSal))

    this.totalSalidaarray[this.init.tabs[this.init.tabindex].indice] = String(dblCostoTotalGlobal);
    this.totalSalidaarray[this.init.tabs[this.init.tabindex].indice] = Number(this.totalSalidaarray[this.init.tabs[this.init.tabindex].indice]).toFixed(this.decimalesTotalSal);
    cantidadbien=Number(cantidadbien / Math.pow(10, this.decimalesCantidadSal));
    this.totalSalidaCantidadarray[this.init.tabs[this.init.tabindex].indice]=String(Number(cantidadbien).toFixed(this.decimalesCantidadSal))

  }
  getencKardex(karnro): Promise<any> {
    return this.http.post<any>(this.way + '/inventario/kardexsalidas/41dd75d9456db0', {
      elementos: {
        p_opcion: 'R',
        p_filtro: 'KAR_ORIGEN = \'PROD\' AND KAR_TIPO=\'SA\' ',
        p_condicion: 'KAR_nro=\'' + karnro + '\''
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertardatosordpro(ordprod) {

    return this.http.post<any[]>(this.way + '/inventario/kardexsalidas/41dde295bee36c00000', {
      elementos: {
        p_prod_numero: ordprod,
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getartsadatosordpro(ordprod, artcod, fecha, hora, bodcod) {

    return this.http.post<any[]>(this.way + '/inventario/kardexsalidas/83bbc53d55ea9800000000000', {
      elementos: {
        p_prod_numero: ordprod,
        p_art_cod: artcod,
        p_fecha: fecha,
        p_hora: hora,
        p_bod_cod: bodcod
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertarEncSalida(encsalida: Invencsalida): Observable<any> {
    this.url = sessionStorage.getItem('url');

    return this.http.post<any[]>(this.way + '/inventario/kardexsalidas/2hhj6bmys5ttxra', {
      elementos: {
        p_KAR_fecha_3: encsalida.KAR_FECHA,
        p_KAR_hora_4: encsalida.KAR_HORA,
        p_KAR_comentario_5: encsalida.KAR_COMENTARIO,
        p_KAR_tipo_2: encsalida.KAR_TIPO,
        p_KAR_origen_6: encsalida.KAR_ORIGEN,
        p_COM_codigo_7: '01',
        p_tipdia_codigo: encsalida.TIPDIA_CODIGO,
        p_KAR_NROCOMPROBANTE: encsalida.KAR_NROCOMPROBANTE,
        p_USUidentificacion_1: encsalida.USUIDENTIFICACION,
        p_encordpro_numero: encsalida.ENCORDPRO_NUMERO,
        p_KAR_SALDOINI: encsalida.KAR_SALDOINI,
        p_KAR_NO_KARDEX: encsalida.KAR_NO_KARDEX,
        p_KAR_ESTADO: encsalida.KAR_ESTADO,
        p_CENTRA_CODIGO:encsalida.CENTRA_CODIGO,
      },
    }, this.confIniciales.httpOptions());
  }
  insertarSalida(salida: Invsalida): Observable<any> {
    this.url = sessionStorage.getItem('url');
    return this.http.post<any[]>(this.way + '/inventario/kardexsalidas/v336arq3rdvr4y', {
      elementos: {
        p_KAR_nro_1: salida.KAR_NRO,
        p_BOD_codigo_2: salida.BOD_CODIGO,
        p_ART_codigo_3: salida.ART_CODIGO,
        p_DETKAR_NRODOC: salida.DETKAR_NRODOC,
        p_DETKAR_cantidad_4: Number(salida.DETKAR_CANTIDAD),
        p_DETKAR_costounit_5: Number(salida.DETKAR_COSTOUNIT),
        p_DETKAR_costototal_6: Number(salida.DETKAR_COSTOTOTAL),
        p_BOD_codigo_ant: salida.BOD_CODIGO,
        p_ART_codigo_ant: salida.ART_CODIGO,
        p_CON_CODIGO: salida.CON_CODIGO,
        p_com_codigo: '01',
        p_detkar_linea: salida.DETKAR_LINEA,
        p_encgre_codigo: salida.ENCGRE_CODIGO,
        p_detgre_linea: salida.DETGRE_LINEA,
        p_detkar_lote: salida.DETKAR_LOTE,
        p_cli_codigo: salida.CLI_CODIGO,
        p_detkar_puntos: salida.DETKAR_PUNTOS,
        p_maepun_codigo: salida.MAEPUN_CODIGO,
        p_detkar_cantidadund: 0,
        p_cen_codigo: salida.CEN_CODIGO,
        
        p_DETKAR_PESO :0 ,
        p_CENTRA_CODIGO:salida.CENTRA_CODIGO
      },
    }, this.confIniciales.httpOptions());
  }
  actualizarKardex_en_sa(encSalida: Invencsalida) {

    return this.http.post<any[]>(this.way + '/inventario/kardexsalidas/8rh8mkj8peth3xu', {
      elementos: {
        p_kar_nro: encSalida.KAR_NRO,
        p_com_codigo: encSalida.COM_CODIGO,
      },
    }, this.confIniciales.httpOptions());

  }
  actualizarEncSalida(encsalida: Invencsalida): Observable<any> {

    return this.http.post<any[]>(this.way + '/inventario/kardexsalidas/9geupxhq6fbs5ps', {
      elementos: {
        p_KAR_nro_1: encsalida.KAR_NRO,
        p_KAR_fecha_3: encsalida.KAR_FECHA,
        p_KAR_hora_4: encsalida.KAR_HORA,
        p_KAR_comentario_5: encsalida.KAR_COMENTARIO,
        p_KAR_tipo_2: encsalida.KAR_TIPO,
        p_KAR_origen_6: encsalida.KAR_ORIGEN,
        p_COM_codigo_7: '01',
        p_tipdia_codigo: encsalida.TIPDIA_CODIGO,
        p_KAR_NROCOMPROBANTE: encsalida.KAR_NROCOMPROBANTE,
        p_USUidentificacion_1: encsalida.USUIDENTIFICACION,
        p_encordpro_numero: encsalida.ENCORDPRO_NUMERO,
        p_KAR_SALDOINI: encsalida.KAR_SALDOINI,
        p_KAR_NO_KARDEX: encsalida.KAR_NO_KARDEX,
        p_KAR_ESTADO: encsalida.KAR_ESTADO,
        p_CENTRA_CODIGO:encsalida.CENTRA_CODIGO
      },
    }, this.confIniciales.httpOptions());
  }
  borrarSalida(salida: Invsalida): Observable<any> {

    return this.http.post<any[]>(this.way + '/inventario/kardexsalidas/6ao6awzzfoda4c3', {
      elementos: {
        p_KAR_nro_1: salida.KAR_NRO,
        p_com_codigo: '01',
        p_detkar_linea: salida.DETKAR_LINEA
      },
    }, this.confIniciales.httpOptions());
  }
  generarAsientoProdProm(salida: Invencsalida, usuident: string) {

    return this.http.post<any[]>(this.way + '/inventario/kardexsalidas/20ebbb6adab928000000000', {
      elementos: {
        p_KAR_NRO: salida.KAR_NRO,
        p_kar_tipo: salida.KAR_TIPO,
        p_com_codigo: '01',
        p_usuario: usuident,
        p_tipdia_codigo: 'OPP',
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  //CDPJ
  getAsiento(salida: Invencsalida): Observable<any> {
    return this.http.post<any[]>(this.way + '/inventario/kardexsalidas/k4l7b22az9tgfsr', {
      elementos: {
        KAR_NRO: salida.KAR_NRO
      },
    }, this.confIniciales.httpOptions());
  }
  getAsientoProm(salida: Invencsalida) {
    return this.http.post<any[]>(this.way + '/inventario/kardexsalidas/k4l7b22az9tgfsr', {
      elementos: {
        KAR_NRO: salida.KAR_NRO
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  calcularpocentaje(){
    let porcentaje=0
    // for (let fila1 = 0; fila1 < this.detkardexsarray[this.init.tabs[this.init.tabindex].indice].length; fila1++) {
    //   porcentaje += this.toScalate(this.detkardexsarray[this.init.tabs[this.init.tabindex].indice][fila1].DETKAR_PORCENTAJE, 2)
    // }
    // porcentaje=Number(porcentaje / Math.pow(10, 2))
    return porcentaje
  }
  validacentrabjo(arreglo,encordprod) {
    if (Object.keys(arreglo).length === 0) {
      return []
    }
    return this.http.post<any[]>(this.way + '/inventario/kardexsalidas/faab26a98ebf7800000000000', {
      elementos: {
        arreglo,
        encordpronumero:encordprod
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
}
